import { ReactElement } from "react"

import CreateAcuDeviceForm from "../../../../components/devices/lct/acu/createAcuDeviceForm"
import ContinueAcuDeviceVersionProvider from "../../../../components/devices/lct/acu/providers/continueAcuDeviceVersionProvider"

const ContinueAcuDraftDeviceVersion = (): ReactElement => (
    <ContinueAcuDeviceVersionProvider>
        <CreateAcuDeviceForm />
    </ContinueAcuDeviceVersionProvider>
)

export default ContinueAcuDraftDeviceVersion
